<template>
    <div v-if="tournament">
        <section class="main-tournament">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">{{ tournament.name }}</h2>
                        <p>Hrajeme od {{ tournament.start | formatDay }} do {{ tournament.end | formatDay }}</p>

                        <ul>
                            <li v-for="(description, idx) in tournament.description" :key="idx">{{ description }}</li>
                        </ul>

                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section v-if="myRank && myRank.score !== null" class="order order--greyback">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle section-subtitle--smallerleft">Aktuální pořadí mého týmu</h2>
                        <v-data-table
                            :headers="headers"
                            :items="[myRank]"
                            :hide-default-footer="true"
                            :items-per-page="5"
                            class="transparent"
                        >
                            <template v-slot:item.rank="{ item }">
                                {{ item.rank | formatRank }}
                            </template>
                            <template v-slot:item.team_name="{ item }">
                                <div class="order__flex">
                                    <team-blazon-view :settings="item.team_blazon" class="small" />
                                    <span>{{ item.team_name }}</span>
                                </div>
                            </template>
                            <template v-slot:item.score="{ item }">
                                {{ item.score }}&nbsp;bodů
                            </template>
                            <template v-slot:item.activation="{ item }">
                                {{ item.activation | formatFullDate }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section v-if="data" class="order order--summary">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle section-subtitle--smallerleft">Celkové pořadí</h2>
                        <v-data-table
                            :headers="headers"
                            :items="data"
                            :items-per-page="100"
                            :loading="loading"
                            :footer-props="{ itemsPerPageOptions: [100], disableItemsPerPage: true }"
                            class="transparent"
                            sort-by="rank"
                        >
                            <template v-slot:item.rank="{ item }">
                                {{ item.rank | formatRank }}
                            </template>
                            <template v-slot:item.team_name="{ item }">
                                <div class="order__flex">
                                    <team-blazon-view :settings="item.team_blazon" class="small" />
                                    <span>{{ item.team_name }}</span>
                                </div>
                            </template>
                            <template v-slot:item.score="{ item }">
                                {{ item.score }}&nbsp;bodů
                            </template>
                            <template v-slot:item.activation="{ item }">
                                {{ item.activation | formatFullDate }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { TOURNAMENTS_LIST_REQUEST, TOURNAMENTS_RANKS_REQUEST } from '../store/actions/tournament';
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView';

    export default {
        name: 'TournamentDetail',
        components: { TeamBlazonView },
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                headers: [
                    {
                        text: 'Pořadí',
                        value: 'rank',
                        sortable: false,
                        align: 'right',
                        width: 100,
                    },
                    {
                        text: 'Tým',
                        value: 'team_name',
                        sortable: false,
                        align: 'left',
                    },
                    {
                        text: 'Počet bodů',
                        value: 'score',
                        sortable: false,
                        align: 'right',
                    },
                    {
                        text: 'Poslední aktivace',
                        value: 'activation',
                        sortable: false,
                        align: 'right',
                        width: 160,
                    },
                ],
                data: [],
                loading: false,
            };
        },
        computed: {
            ...mapState({
                tournaments: state => state.tournament.tournaments,
                myRanks: state => state.tournament.myRanks,
            }),
            tournament () {
                return this.tournaments.find(t => t.id === this.id);
            },
            myRank () {
                return this.myRanks.find(t => t.id === this.id);
            },
        },
        async created () {
            if (this.tournaments.length === 0) {
                await this.$store.dispatch('tournament/' + TOURNAMENTS_LIST_REQUEST);
            }
            try {
                this.loading = true;
                this.data = await this.$store.dispatch('tournament/' + TOURNAMENTS_RANKS_REQUEST, { id: this.id });
            } finally {
                this.loading = false;
            }
        },
    }
</script>
